import taxons from "@/store/knowledge/taxons";
import search from "@/store/knowledge/search";
import articles from "@/store/knowledge/articles";

export default {
    namespaced: true,
    state: {},
    getters: {},
    actions: {},
    mutations: {},
    modules: {
        search,
        taxons,
        articles
    }
};
